import React from 'react';

const Sidebar = ({ categories, selectedCategory, onCategoryChange }) => {
  // Filter to only show specific categories
  const visibleCategories = categories.filter(category => 
    ["All", "Artwork", "Collectibles"].includes(category)
  );

  return (
    <div className="sidebar">
      <h3 className="categories-title">Categories</h3>
      <ul className="categories-list">
        {visibleCategories.map(category => (
          <li 
            key={category} 
            className={`category-item ${selectedCategory === category ? 'active' : ''}`}
            onClick={() => onCategoryChange(category)}
          >
            {category}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;